import { createStyles } from "@mantine/core";
import { INewInstanceDropdownLinkProps } from "./types";
import { DisabledMixin } from "@common/constants/theme-mantine/utils";

export const useStyles = createStyles(
  (theme, { disabled }: Pick<INewInstanceDropdownLinkProps, "disabled">) => ({
    dropdownCard: {
      boxShadow: `0px 4px 20px 0px rgba(0, 0, 0, 0.05)`,
    },

    dropdownLink: {
      borderRadius: theme.spacing.xs,
      color: theme.colors.gray[6],
      textDecoration: "none",
      whiteSpace: "nowrap",
      wordBreak: "keep-all",
      ...DisabledMixin(disabled, "pointer"),

      ".icon svg path": {
        fill: theme.colors.gray[6],
      },

      span: {
        textDecoration: "none",
      },

      "&:hover, &:focus": {
        backgroundColor: theme.colors.brand[0],
        color: theme.colors.brand[5],
        textDecoration: "none",

        ".icon svg path": {
          fill: theme.colors.brand[5],
        },
      },
    },
  }),
);
